import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_53dfa80a from 'nuxt_plugin_plugin_53dfa80a' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_be5ad58e from 'nuxt_plugin_cookieuniversalnuxt_be5ad58e' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_fontawesome_7b6f4bda from 'nuxt_plugin_fontawesome_7b6f4bda' // Source: ./fontawesome.js (mode: 'all')
import nuxt_plugin_axios_461f90de from 'nuxt_plugin_axios_461f90de' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_deviceplugin_9fb8a3c8 from 'nuxt_plugin_deviceplugin_9fb8a3c8' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_gtm_500baea7 from 'nuxt_plugin_gtm_500baea7' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_dayjs_2248fc71 from 'nuxt_plugin_dayjs_2248fc71' // Source: ../../../src/plugins/dayjs (mode: 'all')
import nuxt_plugin_scroll_3c47dc7a from 'nuxt_plugin_scroll_3c47dc7a' // Source: ../../../src/plugins/scroll (mode: 'all')
import nuxt_plugin_vue2datepicker_00e18a49 from 'nuxt_plugin_vue2datepicker_00e18a49' // Source: ../../../src/plugins/vue2-datepicker (mode: 'all')
import nuxt_plugin_admin_221fe5db from 'nuxt_plugin_admin_221fe5db' // Source: ../../../src/plugins/admin (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../../../src/plugins/axios (mode: 'all')
import nuxt_plugin_vuesmoothscrollbar_69b0b6d2 from 'nuxt_plugin_vuesmoothscrollbar_69b0b6d2' // Source: ../../../src/plugins/vue-smooth-scroll-bar (mode: 'all')
import nuxt_plugin_swiper_3a1c5924 from 'nuxt_plugin_swiper_3a1c5924' // Source: ../../../src/plugins/swiper (mode: 'all')
import nuxt_plugin_auth_7635bb7f from 'nuxt_plugin_auth_7635bb7f' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_auth_6a7e4e1e from 'nuxt_plugin_auth_6a7e4e1e' // Source: ../../../src/plugins/auth (mode: 'all')
import nuxt_plugin_services_454c55d4 from 'nuxt_plugin_services_454c55d4' // Source: ../../../src/plugins/services (mode: 'all')
import nuxt_plugin_error_34fb1f5c from 'nuxt_plugin_error_34fb1f5c' // Source: ../../../src/plugins/error (mode: 'all')
import nuxt_plugin_log_5e464c0e from 'nuxt_plugin_log_5e464c0e' // Source: ../../../src/plugins/log (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$app', {
  get() {
    return this.$root.$options.$app
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"kakutoku connect | kakutokuは、営業特化型のクラウドソーシングです。","htmlAttrs":{"lang":"ja","prefix":"og: http:\u002F\u002Fogp.me\u002Fns#"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"kakutokuは、営業特化型のクラウドソーシングです。"},{"hid":"robots","name":"robots","content":"none"},{"hid":"keywords","name":"keywords","content":"カクトク,kakutoku,獲得,営業クラウドソーシング,セールスクラウドソーシング,セールス,営業,クラウドソーシング,求人,営業代行,転職,スタートアップ,営業戦略,テレアポ,ヒアリング,\u003E  クロージング,企画営業,法人営業,シェアリングエコノミー,営業スキル,セールスレップ"},{"hid":"robots","name":"robots","content":"none"},{"hid":"og:locale","property":"og:locale","content":"ja_JP"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:description","property":"og:description","content":"kakutokuは、営業特化型のクラウドソーシングです。"},{"hid":"og:image","property":"og:image","content":""},{"hid":"og:title","property":"og:title","content":"kakutoku connect | kakutokuは、営業特化型のクラウドソーシングです。"},{"hid":"og:url","property":"og:url","content":""},{"hid":"og:site_name","property":"og:site_name","content":"kakutoku connect"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__app_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__APP__ && window.__APP__.state) {
      store.replaceState(window.__APP__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_53dfa80a === 'function') {
    await nuxt_plugin_plugin_53dfa80a(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_be5ad58e === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_be5ad58e(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_7b6f4bda === 'function') {
    await nuxt_plugin_fontawesome_7b6f4bda(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_461f90de === 'function') {
    await nuxt_plugin_axios_461f90de(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_9fb8a3c8 === 'function') {
    await nuxt_plugin_deviceplugin_9fb8a3c8(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_500baea7 === 'function') {
    await nuxt_plugin_gtm_500baea7(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjs_2248fc71 === 'function') {
    await nuxt_plugin_dayjs_2248fc71(app.context, inject)
  }

  if (typeof nuxt_plugin_scroll_3c47dc7a === 'function') {
    await nuxt_plugin_scroll_3c47dc7a(app.context, inject)
  }

  if (typeof nuxt_plugin_vue2datepicker_00e18a49 === 'function') {
    await nuxt_plugin_vue2datepicker_00e18a49(app.context, inject)
  }

  if (typeof nuxt_plugin_admin_221fe5db === 'function') {
    await nuxt_plugin_admin_221fe5db(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesmoothscrollbar_69b0b6d2 === 'function') {
    await nuxt_plugin_vuesmoothscrollbar_69b0b6d2(app.context, inject)
  }

  if (typeof nuxt_plugin_swiper_3a1c5924 === 'function') {
    await nuxt_plugin_swiper_3a1c5924(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7635bb7f === 'function') {
    await nuxt_plugin_auth_7635bb7f(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_6a7e4e1e === 'function') {
    await nuxt_plugin_auth_6a7e4e1e(app.context, inject)
  }

  if (typeof nuxt_plugin_services_454c55d4 === 'function') {
    await nuxt_plugin_services_454c55d4(app.context, inject)
  }

  if (typeof nuxt_plugin_error_34fb1f5c === 'function') {
    await nuxt_plugin_error_34fb1f5c(app.context, inject)
  }

  if (typeof nuxt_plugin_log_5e464c0e === 'function') {
    await nuxt_plugin_log_5e464c0e(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
